import { render, staticRenderFns } from "./cardTemplateVip29.vue?vue&type=template&id=0a5e496c&scoped=true&"
import script from "./cardTemplateVip29.vue?vue&type=script&lang=js&"
export * from "./cardTemplateVip29.vue?vue&type=script&lang=js&"
import style0 from "./cardTemplateVip29.vue?vue&type=style&index=0&id=0a5e496c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5e496c",
  null
  
)

export default component.exports